import React from 'react';
import Zutat from './Zutat';

const FORM_INVALID_STATE = 1;

let zutatLimit = 22;
let zutatenReady = 3;

class ZutatenBlock extends  React.Component {
    constructor(props) {
      super(props);

      this.state = this.props;
       
      this.handleZutatElementChange = this.handleZutatElementChange.bind(this);
      this.addZutat = this.addZutat.bind(this);
    }
    
    handleZutatElementChange(dataContainer) {
      let buffer = null;
      if(dataContainer.deleteElement) {
        buffer = this.state.ingredients;
        delete buffer[dataContainer.keyzc];
        this.setState({  ingredients: buffer });

      } else {
          switch(dataContainer.element) {
          case 'zutat':
            buffer = this.state.ingredients;
            buffer[dataContainer.keyzc].zutat = dataContainer.wert;
            this.setState({  ingredients: buffer });
          break;
          case 'menge':
            buffer = this.state.ingredients;
            buffer[dataContainer.keyzc].menge = dataContainer.wert;
            this.setState({  ingredients: buffer });
          break;
          case 'einheit':
            buffer = this.state.ingredients;
            buffer[dataContainer.keyzc].einheit = dataContainer.wert;
            this.setState({  ingredients: buffer });
          break;
        default:
        break;
        }
        
        
      }
      this.props.onIngredientsChange(this.state.ingredients);
    }

    checkZutatenList(){
      zutatenReady = document.getElementsByClassName('table3')[0].childElementCount;
    }

    addZutat(event) {
      this.checkZutatenList();
      if(zutatenReady < zutatLimit){
        event.preventDefault();
        let buffer = null;
        const   NeueZutat = {};
                NeueZutat.einheit = '';
                NeueZutat.menge = '';
                NeueZutat.zutat = '';
                NeueZutat.deleteVisible = false;
                NeueZutat.deleteElemente = false;
                NeueZutat.schritt = parseInt(this.state.ingredients.length,10 )+1;
                buffer = this.state.ingredients;
                buffer.push(NeueZutat);
                this.setState({  ingredients: buffer });
                this.props.onIngredientsChange(this.state.ingredients);
        zutatenReady++;  
      }
    }
    render() {
      let _this = this;
      let ingredientsValid =  ((this.props.ingredientsIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
      
      return (
       
        <div className="Component Zutaten">
          <section className="tableIngredients">
           <h4 className="label">Zutaten</h4>
           <ul className="header">
            <li>Menge</li>
            <li>Einheit</li>
            <li>Zutat</li>
          </ul>
          <ul className="table3">
           {this.state.ingredients.map(function(zutat, index){
                    return <Zutat key={index} keyzc={index} zutatcontainer={zutat} onZutatElementChange={_this.handleZutatElementChange} />;
                  })}
            </ul>
            <a className="add" href="#addZutat" onClick={this.addZutat}><img className="add_icon" src="/images//i_addRow.svg" alt="nächste Zutat"/> nächste Zutat	</a>
           
           <label className={ingredientsValid}>  
                <span className="field-message">Bitte mindestens eine vollständige Zutat  eingeben</span>
            </label>
            </section>
        </div>
           
      );
    }
  }

  export default ZutatenBlock;


// WEBPACK FOOTER //
// ./src/ZutatenBlock.js